import React, { memo, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';
import { pdfRequested } from '../../../Store/Pdf/action';
import { modalClosed } from '../../../Store/Modal/action';
import { useGetFilterValuesSelected } from '../../../Hook/Interest/UseGetPdfFilterData';

const PdfSelectFilterValuesButton: React.FC = () => {
    const dispatch = useDispatch();
    const filterValuesSelected = useGetFilterValuesSelected();
    const [disabled, setDisabled] = useState<boolean>(true);

    useEffect(() => {
        let isMounted = true;
        if (!isMounted) {
            return;
        }

        setDisabled(filterValuesSelected.length === 0 || filterValuesSelected.length > 3);

        return () => {
            isMounted = false;
        }
    }, [filterValuesSelected]);

    return (
        <Button variant="primary"
                onClick={() => {
                    dispatch(pdfRequested());
                    dispatch(modalClosed());
                }}
                disabled={disabled}
        >
            Keuze bevestigen
        </Button>
    );
}

export default memo(PdfSelectFilterValuesButton);
